// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"af84c829","349":"0b7d9bbe","787":"5902644f"}[chunkId] + ".chunk.js";
};